module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD8SURBVHgB1ZTLDcIwDIadqgN0hI7Q9xXYgA2ACYAJWIENEJMA1z4ZoRsA5774IxFU5URleugnRbbc6K+T2CaaGkI5cRw7QgiLmIRheP0Kp2l6hNnSf7gGQbAQRVFYTdM8EChlkHgssSzDMGxTOp9giT9tiAFObsPMpW/24g4+nIgB3sjuuo50YZn5mhgoUV34jrvZEYO2bWUROLrw0/O8GzHAVT6Vb9BITE/YHLifkiSZ6zHVxn0GZZxl2QG1etEXHm2l7x2UMcrxjPa39XhVVTeWsOu6JcxPbT9KS8O+1Ni80Gd4cIHo0ff9/XfQ53k+IyZ1Xb+iKLrTJHkDKlhVxRg+3yMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/funds/bank-card.png
// module id = dIYd
// module chunks = 0